<template>
  <div>
    <fieldset class="border p-2">
      <legend>
        <small style="font-size: 15px; font-weight: bold"
          >Receive purchase order</small
        >
      </legend>

      <div>
        <form @submit.prevent="newGrn()">
          <div class="row">
            <input type="hidden" class="supplier_id" :value="Supplier.id" />
            <div class="col-md-12">
              <div class="form-group">
                <label>
                  Receiving date
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="date"
                  class="form-control receiving_date input-rounded f-s-14"
                  required
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Product</th>
                    <th scope="col text-right">Unit</th>
                    <th scope="col">Quantity</th>
                    <th scope="col text-right">Unit price</th>
                    <th scope="col text-right">Remark</th>
                    <th scope="col text-right">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(invoice_product, k) in goodsitemsRows" :key="k">
                    <td scope="row">
                      <button
                        type="button"
                        class="btn btn-danger"
                        @click="deleteRow(k, invoice_product)"
                      >
                        <i class="fa fa-trash"></i>
                      </button>
                      <!-- <i class="fa fa-trash-alt" @click="deleteRow(k, invoice_product)"></i> -->
                    </td>
                    <td>
                      <model-list-select
                        :list="systemProducts"
                        v-model="invoice_product.product_id"
                        option-value="id"
                        option-text="product_name"
                        placeholder="select Product"
                      ></model-list-select>
                    </td>
                    <td>
                      <select
                        name="product_measurement"
                        class="form-control input_rounded product_measurement"
                        v-model="invoice_product.product_measurement"
                      >
                        <option value>Select Measurement</option>
                        <option value="KG">KILOGRAMS</option>
                        <option value="PCS">PIECES</option>
                        <option value="LTS">LITRES</option>
                        <option value="SET">SET</option>
                        <option value="PAIR">PAIR</option>
                        <option value="MTR">METRES</option>
                      </select>
                    </td>
                    <td>
                      <input
                        class="form-control"
                        type="number"
                        min="0"
                        step=".01"
                        v-model="invoice_product.qty"
                        @change="calculateLineTotal(invoice_product)"
                      />
                    </td>
                    <td>
                      <input
                        class="form-control"
                        type="number"
                        min="0"
                        step=".01"
                        v-model="invoice_product.unit_price"
                        @change="calculateLineTotal(invoice_product)"
                      />
                    </td>

                    <td>
                      <input
                        class="form-control"
                        type="text"
                        v-model="invoice_product.remarks"
                      />
                    </td>
                    <td>
                      <input
                        readonly
                        class="form-control text-right"
                        type="number"
                        min="0"
                        step=".01"
                        v-model="invoice_product.total_price"
                      />
                    </td>
                  </tr>
                  <tr v-show="goodsitemsRows.length === 0">
                    <td colspan="7">
                      <p class="text-center alert-danger p-2">
                        No products added/available.
                      </p>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="6" class="text-right">Sub Total</td>
                    <input
                      readonly
                      class="form-control text-right sub_total"
                      type="number"
                      min="0"
                      step=".01"
                      :value="invoice_subtotal"
                    />
                  </tr>
                  <tr>
                    <td colspan="6" class="text-right">Total</td>
                    <input
                      readonly
                      class="form-control text-right goods_grand_total"
                      type="number"
                      min="0"
                      step=".01"
                      :value="invoice_total"
                    />
                  </tr>
                </tfoot>
              </table>
            </div>
            <div class="clearfix"></div>
            <div class="col-md-12 mb-2">
              <button type="button" class="btn btn-info" @click="addGoodsItems">
                <i class="fa fa-plus-circle"></i>
                Add
              </button>
            </div>
            <button
              type="submit"
              class="btn btn-primary btn-flat creatingGoodreceiving btn-rounded"
            >
              <i class="fa fa-plus"></i> receive goods
            </button>
            <button
              type="button"
              class="btn-rounded btn-flat creatingGoodreceivingLoader btn-rounded"
            >
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              <i class="fa fa-spinner fa-spin" style="font-size: 24px"></i>
              please wait...
            </button>
          </div>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import $ from "jquery";
import router from "../router/index";
import { ModelListSelect } from "vue-search-select";
export default {
  data() {
    return {
      invoice_subtotal: 0,
      invoice_total: 0,
    };
  },
  created() {
    if (this.$store.getters.Supplier.length === 0) {
      router.push("/suppliergoods");
    }
    this.loadProduct();
  },
  computed: {
    ...mapGetters([
      "PurchaseItem",
      "goodsitemsRows",
      "systemProducts",
      "Purchaseorderitem",
      "Supplier",
    ]),
  },
  methods: {
    ...mapActions(["newGrn", "loadProduct", "getProduct", "loadSuppliers"]),
    ...mapMutations(["addGoodsItems"]),

    calculateTotal() {
      var subtotal, total, totals;
      subtotal = this.goodsitemsRows.reduce(function (sum, product) {
        var lineTotal = parseFloat(product.total_price);
        if (!isNaN(lineTotal)) {
          return sum + lineTotal;
        }
      }, 0);

      if (!isNaN(subtotal)) {
        this.invoice_subtotal = subtotal.toFixed(2);
      } else {
        this.invoice_subtotal = "0.00";
      }
      total = subtotal;
      total = parseFloat(total);
      if (!isNaN(total)) {
        this.invoice_total = total.toFixed(2);
      } else {
        this.invoice_total = "0.00";
      }
    },
    calculateLineTotal(invoice_product) {
      var total =
        parseFloat(invoice_product.unit_price) *
        parseFloat(invoice_product.qty);
      if (!isNaN(total)) {
        invoice_product.total_price = total.toFixed(2);
      }
      this.calculateTotal();
    },
    deleteRow(index, invoice_product) {
      var idx = this.goodsitemsRows.indexOf(invoice_product);
      console.log(idx, index);
      if (idx > -1) {
        this.goodsitemsRows.splice(idx, 1);
      }
      this.calculateTotal();
    },
  },
  components: {
    ModelListSelect,
  },
};
</script>
<style scoped>
.creatingGoodreceivingLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/goodsreceiving/updatepurchaseorder.vue